import React, { createContext, useReducer } from 'react'

enum ActionType {
    TOOGLE_SHEET,
    SET_SELECTED_PRODUCTION,
}

interface ToggleSheetAction {
    type: ActionType.TOOGLE_SHEET
    payload: boolean
}

interface SetSelectedProductionAction {
    type: ActionType.SET_SELECTED_PRODUCTION
    payload: { id: number; webPath: string } | null
}

type Action = ToggleSheetAction | SetSelectedProductionAction

interface State {
    isSheetOpen: boolean
    selectedProduction: { id: number; webPath: string } | null
}

interface Dispatch {
    toggleSheet: (isSheetOpen: boolean) => void
    setSelectedProduction: ({ id, webPath }: { id: number; webPath: string }) => void
}

interface ContextValue {
    state: State
    dispatch: Dispatch
}

export const defaultContextValue: ContextValue = {
    state: {
        isSheetOpen: false,
        selectedProduction: null,
    },
    dispatch: {
        toggleSheet: () => undefined,
        setSelectedProduction: () => undefined,
    },
}
const context = createContext(defaultContextValue)

const toggleSheetAction = (dispatch: React.Dispatch<Action>, isSheetOpen: boolean) => {
    dispatch({ type: ActionType.TOOGLE_SHEET, payload: isSheetOpen })
    if (!isSheetOpen) {
        dispatch({ type: ActionType.SET_SELECTED_PRODUCTION, payload: null })
    }
}

const setSelectedProductionAction = (
    dispatch: React.Dispatch<SetSelectedProductionAction>,
    payload: { id: number; webPath: string },
) => {
    dispatch({ type: ActionType.SET_SELECTED_PRODUCTION, payload })
}

const useDateSwitcherReducer = (): [State, React.Dispatch<Action>] => {
    return useReducer((state: State, action: Action) => {
        switch (action.type) {
            case ActionType.TOOGLE_SHEET:
                return { ...state, isSheetOpen: action.payload }
            case ActionType.SET_SELECTED_PRODUCTION:
                return { ...state, selectedProduction: action.payload }
        }
    }, defaultContextValue.state)
}

export const DateSwitcherProvider: React.FC = ({ children }) => {
    const [state, dispatch] = useDateSwitcherReducer()
    return (
        <context.Provider
            value={{
                state,
                dispatch: {
                    toggleSheet: (isSheetOpen) => toggleSheetAction(dispatch, isSheetOpen),
                    setSelectedProduction: ({ id, webPath }) => setSelectedProductionAction(dispatch, { id, webPath }),
                },
            }}
        >
            {children}
        </context.Provider>
    )
}

export default context
